import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { Stack } from '@mui/system'
import { FC, useContext, useMemo, useState } from 'react'

import { CenteredLoading } from '../../components'
import DviPage from '../../components/DviPage/DviPage'
import { DviRepairOrderCard } from '../../components/Inspections/DviRepairOrderCard'
import { RO_CLOSED } from '../../models/Status'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import { DviListContext } from '../../providers/DviListProvider/DviListProvider'
enum AssignedFilterEnum {
  All = 'All',
  Me = 'Me'
}
const DviJobs: FC = () => {
  const { isLoading, repairOrderLookup, repairOrderByMeLookup } =
    useContext(DviListContext)
  const { repairOrderStatuses } = useContext(AppContext)
  const [assignedFilter, setAssignedFilter] = useState<AssignedFilterEnum>(
    AssignedFilterEnum.Me
  )
  const assignedRepairOrders = useMemo(
    () =>
      assignedFilter === AssignedFilterEnum.Me
        ? Object.values(repairOrderByMeLookup)
        : Object.values(repairOrderLookup),
    [assignedFilter, repairOrderByMeLookup, repairOrderLookup]
  )
  const sortedOpenRepairOrder = useMemo(
    () =>
      repairOrderStatuses
        ? repairOrderStatuses
            .filter((status) => status.id !== RO_CLOSED)
            .map((status) =>
              assignedRepairOrders.filter(
                (ro) =>
                  ro.repairOrder!.info!.status &&
                  ro.repairOrder!.info!.status === status.id
              )
            )
            .flatMap((ro) => ro)
        : [],
    [assignedRepairOrders, repairOrderStatuses]
  )

  return (
    <DviPage title="Active Jobs" isLoading={isLoading}>
      <FormControl fullWidth margin="normal">
        <InputLabel id="assigned-label">Assigned</InputLabel>
        <Select
          labelId="assigned-label"
          label="Assigned"
          value={assignedFilter}
          onChange={(event) =>
            setAssignedFilter(event.target.value as AssignedFilterEnum)
          }>
          <MenuItem value={AssignedFilterEnum.All}>All</MenuItem>
          <MenuItem value={AssignedFilterEnum.Me}>Me</MenuItem>
        </Select>
      </FormControl>
      {isLoading ? (
        <CenteredLoading />
      ) : (
        <Stack spacing={1}>
          {sortedOpenRepairOrder.map((ro) => (
            <DviRepairOrderCard key={ro.repairOrder!.id} repairOrder={ro} />
          ))}
        </Stack>
      )}
    </DviPage>
  )
}

export default DviJobs
